import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Badge } from '../Badge';
import { Row } from '../Layout/Row';
import { Typography } from '../Typography';
import styles from './RecordCard.module.scss';
export const typographyPropsOf = (source)=>({
        variant: source === null || source === void 0 ? void 0 : source.variant,
        skin: source === null || source === void 0 ? void 0 : source.skin,
        weight: source === null || source === void 0 ? void 0 : source.weight,
        ellipsis: source === null || source === void 0 ? void 0 : source.ellipsis
    });
export const totalRowOf = (param)=>{
    let { id, label, amount, struckAmount, aside, isStruck, dividerAbove, testIds } = param;
    return {
        id,
        spread: true,
        dividerAbove,
        dividerSkin: 'subtle',
        label: {
            hideColon: true,
            text: label,
            variant: 'paragraph3'
        },
        value: /*#__PURE__*/ _jsxs(Row, {
            gap: 8,
            alignItems: "baseline",
            children: [
                struckAmount != null && /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph3",
                    skin: "secondary",
                    className: styles.struck,
                    testId: testIds === null || testIds === void 0 ? void 0 : testIds.struckAmount,
                    children: struckAmount
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph2",
                    weight: "normal",
                    className: isStruck ? styles.struck : undefined,
                    testId: testIds === null || testIds === void 0 ? void 0 : testIds.amount,
                    children: amount
                }),
                aside != null && /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph3",
                    skin: "secondary",
                    testId: testIds === null || testIds === void 0 ? void 0 : testIds.aside,
                    children: aside
                })
            ]
        })
    };
};
export const lineRowOf = (param)=>{
    let { key, id, name, amount, struckAmount, leading, badge, gap, variant, labelVariant, shrinkable, isMuted, isStruck, testIds } = param;
    return {
        key,
        id,
        spread: true,
        className: isMuted ? styles.muted : undefined,
        label: {
            hideColon: true,
            shrinkable,
            variant: labelVariant,
            text: /*#__PURE__*/ _jsxs(Row, {
                gap: gap,
                alignItems: "center",
                className: shrinkable ? styles.lineDetails : undefined,
                children: [
                    leading,
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: variant,
                        className: isStruck ? styles.struck : undefined,
                        testId: testIds.name,
                        children: name
                    }),
                    badge != null && /*#__PURE__*/ _jsx(Badge, {
                        size: "small",
                        outlined: true,
                        rounded: true,
                        testId: testIds.badge,
                        children: badge
                    })
                ]
            })
        },
        value: /*#__PURE__*/ _jsxs(Row, {
            gap: 8,
            alignItems: "baseline",
            children: [
                struckAmount != null && /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph3",
                    skin: "secondary",
                    className: styles.struck,
                    testId: testIds.struckAmount,
                    children: struckAmount
                }),
                amount != null && /*#__PURE__*/ _jsx(Typography, {
                    variant: variant,
                    className: isStruck ? styles.struck : undefined,
                    testId: testIds.amount,
                    children: amount
                })
            ]
        })
    };
};
